import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowBtn, ArrowBtnBrown, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../../ui/AllImages'
// import { ContactButton } from '../../ui/CustomElements'

import { useTranslation } from 'react-i18next'
import { AboutBox, ContactButton } from '../../../ui/CustomElements'
import Portfolio from './portfolio/Portfolio'
import Clients from '../clients/Clients'
import { trackSnapWhatsAppClick, waMessage } from '../../../services/snapPixel'
const Projects = () => {
    const { t } = useTranslation()
    const WhatsApp = () => {
        const phoneNumber = '+966560532519';
        const message = waMessage();
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        trackSnapWhatsAppClick('projects');
        window.open(whatsappURL, '_blank');
    };
    return (
        <Box id='portfolio'>
            <ProjectWapper className='container-fluid secProject common-space' id='projeccts'>
                <Container>
                    <Row className='project-row'>
                        <Col md={12} className=''>
                            <Box className='projectContent'>
                                <Box className='projectContentDesc'>
                                    <MainHeading className='main-heading main-heading-sub' size="32px" color="var(--secondaryColor)">
                                        {t('OurProjects')}
                                    </MainHeading>
                                    <MainHeading className='main-heading mb-4'>
                                        {t('ExploreOurPortfolio')}
                                    </MainHeading>
                                </Box>
                                
                                <SpanStyled className='d-flex align-items-center gap-2'>
                                    <ContactButton icon={ArrowBtn} label={t('ContactUs')} onClick={WhatsApp} />
                                </SpanStyled>
                                
                                
                            </Box>
                        </Col>
                       
                        
                    </Row>
                </Container>
                <Box className='stripe stripe1'></Box>
            </ProjectWapper>
            <Portfolio />
            <Clients />
        </Box>
    )
}
const ProjectWapper = styled.section`
    padding-bottom: 50px;
    .projectContent{
        display: flex;
        width: 100%;
        gap: 20px;
        justify-content: space-between;
    }
    
    body.rtl &{
        
    }
    @media (max-width: 767px) {

        .projectContent{
            flex-wrap: wrap;
            gap: 0;
        }
        .projectContentDesc{
            width: 100%;
        }
        
    }
    @media (max-width: 575px) {
        
    }
`
export default Projects
